export default class WorkflowNodeAction {
	/** @type {string | undefined} */
	#workflowId;

	constructor() {
		this.#workflowId = undefined;
		this.wfaction_kid = undefined;
		this.node_kid = undefined;
		this.wf_kid = undefined;
		this.wfstate_kid = undefined;
		this.wfallocatorlist = undefined;
		this.wfcomment = undefined;
	}

	/**
	 * @param {import('angular').IScope} scope
	 * @param {any} wf
	 */
	setScope(scope, wf) {
		scope.$watch(() => wf.wfcomment, () => {
			this.wfcomment = wf.wfcomment;
		});
	}
}
